import React from "react";
import { Moon, Flame } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { ShareButton } from "@/components/ShareButton";

// A calm full-moon Poya observance banner. entry = { poya, isEve }.
export const PoyaBanner = ({ entry, onPlayLamp }) => {
  const { t, lang, fontClass } = useLang();
  if (!entry) return null;
  const { poya, isEve } = entry;
  const name = poya.name[lang] || poya.name.en;
  const sig = poya.sig[lang] || poya.sig.en;

  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 pt-10" data-testid="poya-banner">
      <div className="rounded-3xl p-6 sm:p-8 relative overflow-hidden" style={{ background: "linear-gradient(135deg, #0C0A08 0%, #241a10 55%, #4A2E12 130%)", color: "#FFFDF7", border: "1px solid var(--accent-glow)" }}>
        <div className="flex items-start gap-4">
          <span className="grid place-items-center w-14 h-14 rounded-full shrink-0 sk-glow" style={{ background: "rgba(245,158,11,0.16)", color: "var(--player-accent)" }}>
            <Moon size={28} fill="currentColor" />
          </span>
          <div className="min-w-0">
            <p className="font-ui text-xs font-bold uppercase tracking-widest" style={{ color: "var(--player-accent)" }}>
              {isEve ? t("poya_eve") : t("poya_today")} · 🌕
            </p>
            <h3 className={`${fontClass()} text-2xl sm:text-3xl font-bold mt-1`}>{name}</h3>
            {poya.meheni && (
              <p className="font-ui text-sm font-bold mt-2 inline-flex items-center gap-1.5" style={{ color: "var(--player-accent)" }}>
                🙏 {t("poya_meheni")}
              </p>
            )}
            <p className={`${fontClass()} text-base leading-relaxed mt-2`} style={{ color: "rgba(255,255,255,0.85)" }}>{sig}</p>
            {onPlayLamp && (
              <button
                onClick={onPlayLamp}
                data-testid="poya-play-lamp"
                className="mt-5 inline-flex items-center gap-2 h-12 px-6 rounded-full font-ui text-base font-bold transition-transform active:scale-95 hover:scale-105 sk-glow"
                style={{ background: "var(--player-accent)", color: "var(--player-bg)" }}
              >
                <Flame size={20} /> {t("poya_listen")}
              </button>
            )}
            <div className="mt-4">
              <ShareButton
                testid="poya-share"
                dark
                text={`🌕 ${name}\n${poya.meheni ? "🙏 " + t("poya_meheni") + "\n" : ""}${sig}`}
                url={`${typeof window !== "undefined" ? window.location.origin : ""}/rooms/sindu-kamare`}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
